export const NAME = "kitName";
export const DESCRIPTION = "description";
export const KIT_TYPE = "kitType";


export const Kit_options = {
  TLM: "TLM",
  Books: "Books",
  Stocking: "Stocking",
  None: "None",
};